// path: src/index.js

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { bootstrapNativeShell } from "./nativeBootstrap";

bootstrapNativeShell();

ReactDOM.render(<App />, document.getElementById("root"));

// Force-remove any old CRA service worker that may have been registered
// by a previous build/deploy.
serviceWorker.unregister();

if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
            registration.unregister();
        });
    });
}

if ("caches" in window) {
    caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
        });
    });
}